import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom';
import { orderStatuses } from '../../names';

export const ModernOrdersCount = ({orders}) => {

    const [isReady, setIsReady] = useState(false);
    useEffect(() => {
        setIsReady(true);
    });

    if (!isReady) {
        return null;
    }

    const ordersCount = orders.filter(o => o.orderStatus.name === orderStatuses.MODERN).length;

    return createPortal(
        <div>
            модернов: <b>{ordersCount}</b>
        </div>,
        document.getElementById('moderns-count-root'),
    );
}
